import { derived, writable } from "./customStores";
const FIRST_TIMESTAMP = Date.now();
export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["HANDLED_ERROR"] = "HANDLED_ERROR";
    LogLevel["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
})(LogLevel || (LogLevel = {}));
export var LogCategory;
(function (LogCategory) {
    LogCategory["USER_INPUT"] = "USER_INPUT";
    LogCategory["EXECUTION"] = "EXECUTION";
    LogCategory["INIT"] = "INIT";
    LogCategory["UNCAUGHT"] = "UNCAUGHT";
})(LogCategory || (LogCategory = {}));
export class Logger {
    constructor() {
        this._logs = writable([]);
        this.logs = derived(this._logs, value => value);
    }
    static getInstance() {
        return Logger.instance;
    }
    log(message, level, ...categories) {
        this._logs.update(logs => [
            ...logs,
            {
                message,
                timestamp: elapsed(),
                level,
                categories: [...categories]
            }
        ]);
    }
    debug(message, ...categories) {
        this.log(message, LogLevel.DEBUG, ...categories);
    }
    warning(message, ...categories) {
        this.log(message, LogLevel.WARNING, ...categories);
    }
    handled_error(message, ...categories) {
        this.log(message, LogLevel.HANDLED_ERROR, ...categories);
    }
    unexpected_error(message, ...categories) {
        this.log(message, LogLevel.UNEXPECTED_ERROR, ...categories);
    }
}
Logger.instance = new Logger();
const logger = Logger.getInstance();
// milliseconds from when FIRST_TIMESTAMP was set
function elapsed() {
    return Date.now() - FIRST_TIMESTAMP;
}
export default logger;
